import About from "../components/AboutMe";
import Services from "../components/Services";
import Contact from "../components/ContactMe";

export default function Main() {
  return (
    <div>
      <About />
      <Services />
      <Contact />
    </div>
  );
}
